import { sysUrl } from '@/globals'

type IModelData = {[k:string]: null|number|string|boolean}

let g_nextId = 1

export async function invoke(method: string, ...params: any[]) {
  let body = JSON.stringify({ id: g_nextId++, method, params })
  let req = new Request(sysUrl + '/rpc/', { method: 'POST', mode: 'cors', credentials: 'include', body })
  let resp = await fetch(req)
  if (!resp.ok) {
    throw new Error(`${resp.status} (${resp.statusText})`);
  }
  let ret = await resp.json();
  if (ret.error) {
    throw new Error(`${ret.error.code} (${ret.error.message})`);
  }
  return ret.result;
}

export async function batch(calls: ({ method: string, params?: any[] } | string)[]) {
  let reqList = calls.map(v => {
    if (typeof v === 'string') {
      return {id: g_nextId++, method: v}
    }
    else {
      return { id: g_nextId++, method: v.method, params: v.params }
    }
  })
  let req = new Request(sysUrl + '/rpc/', { method: 'POST', mode: 'cors', credentials: 'include', body: JSON.stringify(reqList) })
  let resp = await fetch(req)
  if (!resp.ok) {
    throw new Error(`${resp.status} (${resp.statusText})`);
  }
  let ret = await resp.json();
  if (!Array.isArray(ret)) {
    throw new Error('invalid response');
  }
  let results: any[] = []
  for (let req of reqList) {
    let id = req.id
    let r = ret.find(v => v.id == id)
    if (r) {
      if (r.error) {
        throw new Error(`${r.code} (${r.message})`);
      }
      results.push(r.result)
    }
  }
  return results
}

export namespace item {
  export async function get(id: number) {
    return invoke('item/get', id)
  }

  export async function list(nodeId: number, fields?: string[]) {
    return invoke('item/listOfNode', nodeId, fields)
  }

  export async function create(data: IModelData) {
    return invoke('item/create', data)
  }

  export async function update(id: number, data: IModelData) {
    return invoke('item/update', id, data)
  }

  export async function updateArray(list: {id: number, data: IModelData}[]) {
    return batch(list.map(v => ({ method: 'item/update', params: [v.id, v.data] })))
  }

  export async function remove(id: number) {
    return invoke('item/delete', id)
  }

  export async function removeArray(idList: number[]) {
    return batch(idList.map(v => ({ method: 'item/delete', params: [v] })))
  }
}

export namespace node {
  export async function get(id: number, portalKey: string, fields?: 0 | 1 | string[]) {
    return invoke('node/get', id, portalKey)
  }

  export async function formValues(id: number, portalKey: string) {
    return invoke('node/formValues', id, portalKey)
  }

  export async function create(data: IModelData) {
    return invoke('node/create', data);
  }

  export async function update(id: number, data: IModelData, meta?: IModelData) {
    return invoke('node/update', id, data, meta)
  }

  export async function updateArray(list: {id: number, data: IModelData, meta?: IModelData}[]) {
    return batch(list.map(x => ({ method: 'node/update', params: [x.id, x.data] })))
  }

  export async function remove(id: number) {
    return invoke('node/delete', id)
  }

  export async function removeArray(list: {id: number, meta?: IModelData}[]) {
    return await batch(list.map(x => ({method: 'node/delete', params: [x.id]})))
  }
}
